import Link from "next/link";
import Image from "next/image";
import { StyledButton } from "@/components/common/styledButton";
import { HTMLAttributeAnchorTarget, JSX } from "react";
import { DiscordIcon, XIcon, TelegramIcon, ArrowIcon } from "@/icons";

interface FooterLinksDataType {
  linkName: string;
  linkHref: string;
  linkTarget: HTMLAttributeAnchorTarget;
}

export default function Footer() {
  const LinkData01: FooterLinksDataType[] = [
    {
      linkName: "TERMS & CONDITIONS",
      linkHref:
        "https://campfoundation.notion.site/Camp-Terms-of-Service-eba426fcea184a90bc4bd26fd795bdbe",
      linkTarget: "_blank",
    },
    {
      linkName: "PRIVACY POLICY",
      linkHref:
        "https://campfoundation.notion.site/",
      linkTarget: "_blank",
    },
  ];
  const LinkData02: FooterLinksDataType[] = [
    {
      linkName: "DOCS",
      linkHref: "https://docs.campnetwork.xyz",
      linkTarget: "_blank",
    },
  ];

  const scocialLinks: {
    icon: JSX.Element;
    linkHref: string;
    linkTarget: HTMLAttributeAnchorTarget;
  }[] = [
    {
      icon: <XIcon />,
      linkHref: "https://x.com/campnetworkxyz",
      linkTarget: "_blank",
    },
    {
      icon: <DiscordIcon />,
      linkHref: "https://discord.com/invite/campnetwork",
      linkTarget: "_blank",
    },
    {
      icon: <TelegramIcon />,
      linkHref: "https://t.me/CampNetworkCommunity",
      linkTarget: "_blank",
    },
  ];

  return (
    <div className="w-full flex-col border-t border-[#261000]/15">
      <div className="mx-auto w-full max-w-6xl flex-col items-center justify-center p-4 px-4 max-sm:px-6 md:p-8 md:px-[76px]">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-4">
            <div className="flex flex-col gap-6">
              <p className="font-mono text-sm font-medium text-[#1A1A1A]/50">
                LEGAL
              </p>
              <div className="flex flex-col gap-4">
                {LinkData01.map((link) => (
                  <div key={link.linkName} className="flex">
                    <Link href={link.linkHref} target={link.linkTarget}>
                      <p className="font-mono text-sm font-medium text-[#1A1A1A] transition-colors duration-150 hover:text-[#FF6D01]">
                        {link.linkName}
                      </p>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col gap-6">
              <p className="font-mono text-sm font-medium text-[#1A1A1A]/50">
                RESOURCES
              </p>
              <div className="flex flex-col gap-4">
                {LinkData02.map((link) => (
                  <div key={link.linkName} className="flex">
                    <Link href={link.linkHref} target={link.linkTarget}>
                      <p className="font-mono text-sm font-medium text-[#1A1A1A] transition-colors duration-150 hover:text-[#FF6D01]">
                        {link.linkName}
                      </p>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="flex flex-col items-start lg:items-end">
            <div className="flex w-full flex-row items-center justify-start gap-4 lg:justify-end lg:gap-6">
              <div className="flex flex-row items-center gap-2">
                {scocialLinks.map((link, index) => (
                  <Link
                    key={index}
                    href={link.linkHref}
                    target={link.linkTarget}
                    className="group cursor-pointer transition-colors duration-150 hover:bg-[#FF5101]/10">
                    <div className="transition-transform duration-150 group-hover:scale-110">
                      {link.icon}
                    </div>
                  </Link>
                ))}
              </div>
              <StyledButton
                onClick={() =>
                  window.open("https://docs.campnetwork.xyz/", "_blank")
                }
                className="relative cursor-pointer rounded-none bg-[#FF6D01] px-4 py-3 font-mono text-xs font-semibold text-white uppercase hover:bg-[#FF5101]">
                Start Building
                <ArrowIcon />
                <span className="absolute top-1 left-1 aspect-square size-1 bg-white/30" />
                <span className="absolute top-1 right-1 aspect-square size-1 bg-white/30" />
                <span className="absolute bottom-1 left-1 aspect-square size-1 bg-white/30" />
                <span className="absolute right-1 bottom-1 aspect-square size-1 bg-white/30" />
              </StyledButton>
            </div>
          </div>
        </div>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-4 sm:flex-row sm:justify-between sm:gap-2 md:mt-18">
          <Link href="/">
            <Image
              priority
              alt="Logo"
              width={100}
              height={50}
              className="h-auto w-20"
              src="/assets/camp-logo.png"
            />
          </Link>
          <p className="flex flex-row items-center gap-3 font-mono text-sm font-medium text-[#1A1A1A]">
            <span>© {new Date().getFullYear()} Camp Network</span>
            <span className="aspect-square size-4 bg-[#1A1A1A]" />
          </p>
        </div>
      </div>
    </div>
  );
}
